import { apiFetch } from "./http";
import type { EntrarRequest, EntrarResponse, MeResponse } from "@/types/auth";

export const authApi = {
  // Etapa 1 (somente email) e Etapa 2 (email + sessao_login_id + codigo_otp)
  entrar(body: EntrarRequest) {
    return apiFetch<EntrarResponse>("/api/auth/entrar", { method: "POST", body });
  },

  me() {
    return apiFetch<MeResponse>("/api/auth/me");
  },

  sair() {
    return apiFetch<unknown>("/api/auth/sair", { method: "POST" });
  },
};
